import { render, staticRenderFns } from "./UserShippingAddresses.vue?vue&type=template&id=88cffe30&scoped=true&"
import script from "./UserShippingAddresses.vue?vue&type=script&lang=ts&"
export * from "./UserShippingAddresses.vue?vue&type=script&lang=ts&"
import style0 from "./UserShippingAddresses.vue?vue&type=style&index=0&id=88cffe30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cffe30",
  null
  
)

export default component.exports